// BN,ID,MY,PH,SG,TH,VN,JP,KR,CN,MO,HK,TW 使用黄种人头像，其他地区使用白种人头像,暂未使用黑种人头像;
// 飞书文档:https://arashivision.feishu.cn/wiki/PScXwthLcicioekzyfncGOA6nlf?sheet=iD7ril
export const YELLOW_AVATAR_LIST = ['BN', 'ID', 'MY', 'PH', 'SG', 'TH', 'VN', 'JP', 'KR', 'CN', 'MO', 'HK', 'TW'];
export const AVATAR = {
  WHITE: 'https://res.insta360.com/static/566166e08e5d2963ed122260cc20b1af/W.png',
  YELLOW: 'https://res.insta360.com/static/e4d28d08906de8461a541952ce1df060/Y.png',
  BLACK: 'https://res.insta360.com/static/6129e3262b7027e59d0a4e3fbc76af69/B.png',
};
